import React, {useContext} from "react";
import Button from "./Button";
import {UserContext} from "./UserContext";
import EllipsisToolTip from "../components/EllipsisToolTip";

const ListItemTodo = props => {
    const {todo, onClick} = props;
    const {user} = useContext(UserContext);

    return (
        <tr>
            <td>
                <EllipsisToolTip className={'ch-list-item-title'} tooltip={todo.title}>{todo.title}</EllipsisToolTip>
            </td>
            {todo.toDoType == 'FOLLOWUP_WORK' ? <>
                    <td>
                        {todo.dueDate !== undefined ? user.dateFormat.format(todo.dueDate) : ''}
                    </td>
                    <td className={'ch-align-center'}>
                        {todo.skillsCount !== undefined ? todo.skillsCount : ''}
                    </td>
                </> :
                <>
                    <td>
                        {todo.startDate !== undefined &&
                            <>{user.dateFormat.format(todo.startDate)}</>
                        }
                    </td>
                    <td>
                        {todo.toDoType != 'FOLLOWUP_WORK' && todo.endDate !== undefined &&
                            <>{user.dateFormat.format(todo.endDate)}</>
                        }
                    </td>
                </>
            }
            <td className={'ch-align-center'}>
                <Button type={'text'} onClick={onClick}>
                    {todo.toDoType == 'FOLLOWUP_WORK' ? <>View Feedback</> : <>Start</>}
                </Button>
            </td>
        </tr>
    )
}

export default ListItemTodo;